/* js-cart-notification FIXED */

var CartNotification = {
  init: function () {
    if (CartNotification._initialized) return;
    CartNotification._initialized = true;

    const root = window.Shopify?.routes?.root || '/';

    /* -------------------------
       OPEN / CLOSE CART
    ------------------------- */

    $(document).on('click', 'a[href="#open-cart"], .site-header__cart-link', function (e) {
      e.preventDefault();
      history.pushState(null, null, ' ');
      openCart();
    });

    $(document).on('click', '.button-close-cart', closeCart);
    $(document).on('click', '.cart-notification__close, .cart-notification__pay .cart-notification__button--secondary', function (e) {
      e.preventDefault();
      closeCart();
    });

    $(document).on('click', function (e) {
      if (!$(e.target).closest('.button-add-cart, .cart-notification, a[href="#open-cart"], .site-header__cart-link').length) {
        closeCart();
      }
    });

    function openCart() {
      $('.cart-notification').addClass('cart-notification-active');
      $('body').addClass('cart-notification-open');
    }

    function closeCart() {
      $('.cart-notification').removeClass('cart-notification-active');
      $('body').removeClass('cart-notification-open');
    }

    /* -------------------------
       ADD TO CART
    ------------------------- */

    $(document).on('click', '.button-add-cart', function () {
      const $btn = $(this);

      if ($btn.hasClass('product-unavailable') || $btn.prop('disabled')) {
        return;
      }

      const productID = Number($btn.attr('data-id'));
      const randomID = Math.floor(Math.random() * 1e9);
      const $productData = $btn.closest('.add-cart-wrapper').find('#product_data');

      let productQty = 1;

      if ($productData.length) {
        productQty = Math.max(
          1,
          parseInt($productData.find('input[name="quantity"]').val(), 10) || 1
        );
      }

      if (!productID || isNaN(productID)) {
        console.error('Variant ID invàlid:', $btn.attr('data-id'));
        return;
      }

      $btn.addClass('product-adding');

      const items = [];

      /* --- ADDONS --- */
      $productData.find('[name="product_addon"]').each(function () {
        const $addon = $(this);

        const qty = parseInt($addon.find('[name="quantity"]').val(), 10) || 0;
        if (qty <= 0) return;

        const propName = $addon.find('[name="property"]').data('name');
        const propValue = $addon.find('[name="property"]').data('value');

        const properties = { _link: randomID };

        if (propName) properties[propName] = propValue;

        items.push({
          id: Number($addon.data('id')),
          quantity: qty,
          properties
        });
      });

      /* --- PROPERTIES PRODUCTE PRINCIPAL --- */
      const properties = {};

      $productData.find('[name="product_property"]').each(function () {
        const propName = $(this).data('name');
        const propValue = $(this).data('value');

        if (propName) properties[propName] = propValue;
      });

      if (items.length) {
        properties._mlink = randomID;
      }

      /* --- PRODUCTE PRINCIPAL --- */
      const mainItem = {
        id: productID,
        quantity: productQty
      };

      if (Object.keys(properties).length) {
        mainItem.properties = properties;
      }

      items.push(mainItem);

      addToCart(
        {
          items,
          sections: ['section-cart-notification']
        },
        $btn
      );
    });

    /* -------------------------
       AJAX ADD TO CART
    ------------------------- */

    function addToCart(payload, $btn) {
      const body = {
        items: payload.items || [],
        sections: Array.isArray(payload.sections)
          ? payload.sections
          : ['section-cart-notification'],
        sections_url: window.location.pathname
      };

      $.ajax({
        url: root + 'cart/add.js',
        method: 'POST',
        data: JSON.stringify(body),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json'
      })
        .done(function (data) {
          updateCartNotificationHTML(data);
          openCart();
        })
        .fail(function (xhr) {
          const msg =
            xhr?.responseJSON?.description ||
            xhr?.responseJSON?.message ||
            'Error afegint el producte.';

          alert(msg);

          console.error('ADD TO CART ERROR:', {
            status: xhr.status,
            response: xhr.responseJSON || xhr.responseText
          });
        })
        .always(function () {
          if ($btn) $btn.removeClass('product-adding');
        });
    }

    CartNotification.addToCart = addToCart;

    /* -------------------------
       UPDATE CART HTML
    ------------------------- */

    function updateCartNotificationHTML(data) {
      const html = data?.sections?.['section-cart-notification'];

      if (!html) {
        console.warn('No sections returned', data);
        openCart();
        updateCartTotals();
        return;
      }

      const $cartEl = $('.cart-notification__products');
      const $sectionHtml = $('<div>').append($.parseHTML(html, document, true));
      const $items = $sectionHtml.find('.cart-notification__products__item');

      $cartEl.empty().append($items.length ? $items : $sectionHtml.contents());

      bindCartEvents();
      updateCartTotals();
    }

    function refreshCartNotificationHTML() {
      $.getJSON(root + '?sections=section-cart-notification')
        .done(function (sections) {
          updateCartNotificationHTML({ sections });
        })
        .fail(updateCartTotals);
    }

    /* -------------------------
       REMOVE ITEM
    ------------------------- */

    function removeFromCart($item) {
      if ($item.data('line') === 'removed') return;

      const changes = [{ line: $item.data('line'), quantity: 0 }];
      let $itemsToRemove = $item;
      $item.data('line', 'removed');
      $item.addClass('cart-item-removing');

      const mlink = $item.data('mlink');

      if (mlink) {
        $('.cart-notification__products__item').each(function () {
          const $linked = $(this);

          if ($linked.data('link') == mlink && $linked.data('line') !== 'removed') {
            changes.push({
              line: $linked.data('line'),
              quantity: 0
            });

            $linked.data('line', 'removed');
            $linked.addClass('cart-item-removing');
            $itemsToRemove = $itemsToRemove.add($linked);
          }
        });
      }

      const doChanges = (list) => {
        if (!list.length) {
          afterRemove($itemsToRemove);
          return;
        }

        $.post(root + 'cart/change.js', list[0], null, 'json')
          .done(() => doChanges(list.slice(1)))
          .fail(function () {
            alert('No s’ha pogut eliminar el producte.');
            $itemsToRemove.removeClass('cart-item-removing');
            updateCartTotals();
          });
      };

      doChanges(changes);
    }

    function afterRemove($items) {
      $items.fadeOut(200, function () {
        $(this).remove();
      });

      setTimeout(refreshCartNotificationHTML, 220);
    }

    /* -------------------------
       EVENTS (ITEMS)
    ------------------------- */

    function bindCartEvents() {
      const $items = $('.cart-notification__products__item');

      /* REMOVE */
      $items.find('.btn-remove').off('click').on('click', function () {
        removeFromCart($(this).closest('.cart-notification__products__item'));
      });

      /* PLUS */
      $items.find('.plus').off('click').on('click', function () {
        const $input = $(this).siblings('input[type=number]');
        if ($input[0]) $input[0].stepUp();
        $input.trigger('change');
      });

      /* MINUS */
      $items.find('.minus').off('click').on('click', function () {
        const $input = $(this).siblings('input[type=number]');
        if ($input[0]) $input[0].stepDown();
        $input.trigger('change');
      });

      /* CHANGE QTY */
      $items
        .find('.cart-notification__products__item__quantity')
        .off('change')
        .on('change', function () {
          const $input = $(this);
          const $item = $input.closest('.cart-notification__products__item');

          const line = $item.data('line');
          const newQty = parseInt($input.val(), 10) || 0;

          $.post(root + 'cart/change.js', { line, quantity: newQty }, null, 'json')
            .fail(function () {
              alert('No hi ha prou estoc disponible.');
              $input.val($input.attr('data-qty'));
            })
            .always(updateCartTotals);
        });
    }

    /* -------------------------
       TOTALS
    ------------------------- */

    function updateCartTotals() {
      let totalQty = 0;
      let totalAmount = 0;

      $('.cart-notification__products__item').each(function () {
        const $item = $(this);

        if ($item.data('line') === 'removed') return;

        const qty =
          parseInt(
            $item.find('.cart-notification__products__item__quantity').val(),
            10
          ) || 1;

        const price =
          parseFloat($item.find('[data-price]').data('price')) || 0;

        totalQty += qty;
        totalAmount += qty * price;
      });

      $('.cart-notification__bottom .cart-notification__price').html(
        formatMoney(totalAmount)
      );

      updateHeaderCartCount(totalQty);

      if (totalQty === 0) {
        $('.cart-empty').css('display', 'flex');
        $('.cart-notification--topwrapper').hide();
      } else {
        $('.cart-empty').hide();
        $('.cart-notification--topwrapper').show();
      }
    }

    function updateHeaderCartCount(totalQty) {
      $('.num-cart').html(totalQty);

      $('.site-header__cart-link').each(function () {
        const $link = $(this);
        let $count = $link.find('.site-header__cart-count');

        if (totalQty <= 0) {
          $count.remove();
          return;
        }

        if (!$count.length) {
          $count = $('<span class="site-header__cart-count"></span>');
          $link.append($count);
        }

        $count.html(totalQty);
      });
    }

    /* INIT */
    updateCartTotals();
    bindCartEvents();
  }
};

CartNotification.init();
